<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Change Session Pricing</p>
      </header>
      <app-editsessionrateset [Session]="Session"></app-editsessionrateset>
    </div>
  </div>